import React from 'react';
import FinancingNotEligible from 'Modules/fortiva/components/FinancingNotEligible';
import OfferAgreement from 'Modules/fortiva/components/OfferAgreement';

export default function SelectOffer({
  offers,
  selectedOffer,
  setSelectedOffer,
  enableSignContract,
  navigateToFinalizeTab,
  amount_to_pay,
  already_paid_amount,
  approval,
  routes,
  selected_offer_id,
  downPayment = 0,
  onBack,
}) {
  const installment = offers?.installment?.[0];
  const offerType = installment?.type || '';
  const term = installment?.terms?.[0] || {};
  const { id, require_downpayment_percent = 0 } = term;

  const downPaymentValue = Number(downPayment) || 0;
  const financedAmount = Math.max(amount_to_pay - already_paid_amount - downPaymentValue, 0);
  const isEligible = Boolean(id) && financedAmount > 0;
  const isSelected = selectedOffer?.id === id;

  const installmentList = offers?.installment || [];
  const isSingleOffer =
    installmentList.length === 1 && (installmentList[0]?.terms || []).length === 1;

  React.useEffect(() => {
    if (!id) return;
    const matchesPersisted = selected_offer_id && selected_offer_id === id;
    if (!matchesPersisted && !isSingleOffer) return;
    setSelectedOffer({
      id,
      require_downpayment_percent,
      type: offerType,
    });
  }, [
    id,
    selected_offer_id,
    require_downpayment_percent,
    offerType,
    setSelectedOffer,
    isSingleOffer,
  ]);

  const handleSelectOffer = () => {
    if (!isSelected) {
      setSelectedOffer({
        id,
        require_downpayment_percent,
        type: offerType,
      });
    }
    navigateToFinalizeTab?.();
  };

  if (!installment) {
    return null;
  }

  if (!isEligible && !enableSignContract) {
    return (
      <div className="flex justify-center flex-wrap">
        <FinancingNotEligible
          already_paid_amount={already_paid_amount}
          amount_to_pay={amount_to_pay}
          routes={routes}
          exceedsCreditLimit={false}
          approval={approval}
          financedAmount={financedAmount}
        />
      </div>
    );
  }

  return (
    <OfferAgreement
      installment={installment}
      amount_to_pay={amount_to_pay}
      already_paid_amount={already_paid_amount}
      downPayment={downPaymentValue}
      approval={approval}
      isSelected={isSelected}
      onSelectOffer={handleSelectOffer}
      onBack={onBack}
      canSelect={enableSignContract || isEligible}
    />
  );
}
